import React from 'react';
import { FileOrFormQuestion } from '../FileOrFormQuestion';
import { usePropertyGcResumeFile } from '../../../../queries/PropertyFileFields/NonRentalFiles';

interface GeneralContractorFileParameter {
    propertyGuid: string;
    required: boolean;
    isReview?: boolean;
}

export const GeneralContractorFile: React.FC<GeneralContractorFileParameter> = ({ propertyGuid, required, isReview = false }) => {
    const { handleMode, setHandleMode, filename: uploadFileName, setFilename: setUploadFileName, fileApiId: uploadedFileApiId, setFileApiId: setUploadedFileApiId, gcData, setGcData } = usePropertyGcResumeFile(propertyGuid);

    return (
        <div className='form-group'>
            <div className='row'>
                <FileOrFormQuestion
                    label='G.C. Resume'
                    selector='generalcontractorresume'
                    fileType='general contractor resume'
                    required={required}
                    isReview={isReview}
                    propertyGuid={propertyGuid}
                    handle={handleMode}
                    onHandleChange={setHandleMode}
                    uploadFileName={uploadFileName}
                    onUploadFileNameChange={setUploadFileName}
                    uploadedFileApiId={uploadedFileApiId}
                    onUploadedFileApiIdChange={setUploadedFileApiId}
                    data={gcData ?? ''}
                    set_data={(v) => setGcData(v)}
                />
            </div>
        </div>
    );
};
